module.exports = __webpack_public_path__ + "img/8.09ec29f0.jpg";